import { createContext } from "react"
import { DefaultMoughataaInterface, moughataaInterface } from "../../moughataa/types"

export const OwnerType = [
  { _id: "docteur", name: "docteur" },
  { _id: "investisseur", name: "investisseur" },
]

export const SexType = [
  { _id: "masculin", name: "masculin" },
  { _id: "feminin", name: "feminin" },
]

export interface FormCabinetInterface {
  name: string, setName: (name: string) => void,
  phone: string, setPhone: (phone: string) => void,
  address: string, setAddress: (address: string) => void,
  logo: File | any, setLogo: (logo: File | any) => void,
  authorization: string, setAuthorization: (authorization: string) => void,
  type: string, setType: (type: string) => void,
  moughataa: any, setMoughataa: (moughataa: any) => void,
  chooseDoctor: any, setChooseDoctor: (chooseDoctor: any) => void,
  existedDoctor: boolean, setExistedDoctor: (existedDoctor: boolean) => void,

  fullName: string, setFullName: (fullName: string) => void,
  yearOfBirth: string, setYearOfBirth: (yearOfBirth: string) => void,
  placeOfBirth: string, setPlaceOfBirth: (placeOfBirth: string) => void,
  sex: string, setSex: (sex: string) => void,
  telephone: string, setTelephone: (telephone: string) => void,
  whatsapp: string, setWhatsapp: (whatsapp: string) => void,
  email: string, setEmail: (email: string) => void,
  current: string, setCurrent: (current: string) => void,
  medecinType: any, setMedecinType: (medecinType: any) => void,
  origin: string, setOrigin: (origin: string) => void,
  inscriptionDate: string, setInscriptionDate: (inscriptionDate: string) => void,
  avatar: File | any, setAvatar: (avatar: File | any) => void,
  password: string, setPassword: (password: string) => void,
  speciality: string, setSpeciality: (speciality: string) => void,
}

export const DefaultFormCabinetInterface: FormCabinetInterface = {
  name: "", setName: () => {},
  phone: "", setPhone: () => {},
  address: "", setAddress: () => {},
  logo: null, setLogo: () => {},
  authorization: "", setAuthorization: () => {},
  type: "", setType: () => {},
  moughataa: null, setMoughataa: () => {},
  chooseDoctor: null, setChooseDoctor: () => {},
  existedDoctor: false, setExistedDoctor: () => {},

  fullName: "", setFullName: () => {},
  yearOfBirth: "", setYearOfBirth: () => {},
  placeOfBirth: "", setPlaceOfBirth: () => {},
  sex: "", setSex: () => {},
  telephone: "", setTelephone: () => {},
  whatsapp: "", setWhatsapp: () => {},
  email: "", setEmail: () => {},
  current: "", setCurrent: () => {},
  medecinType: "", setMedecinType: () => {},
  origin: "", setOrigin: () => {},
  inscriptionDate: "", setInscriptionDate: () => {},
  avatar: null, setAvatar: () => {},
  password: "", setPassword: () => {},
  speciality: "", setSpeciality: () => {},
}

export const FormCabinetContext = createContext<FormCabinetInterface>(DefaultFormCabinetInterface)

export interface cabinetInterface {
  _id: any,
  name: string,
  phone: string,
  address: string,
  logo: string,
  authorization: string,
  type: string,
  moughataa: moughataaInterface
}

export const DefaultcabinetInterface: cabinetInterface =  {
  _id: null,
  name: "",
  phone: "",
  address: "",
  logo: "",
  authorization: "",
  type: "",
  moughataa: DefaultMoughataaInterface,
}

export interface ShowCabinetInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showDeleteModal: boolean, setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedCabinet: cabinetInterface, setSelectedCabinet: (selectedCabinet: cabinetInterface) => void,
}

export const DefaultShowCabinetInterface:ShowCabinetInterface = {
  showSuccessMsg: false, setShowSuccessMsg:() => {},
  showDeleteModal: false, setShowDeleteModal: () => {},
  selectedCabinet: DefaultcabinetInterface, setSelectedCabinet: () => {},
}

export const ShowCabinetContext = createContext<ShowCabinetInterface>(DefaultShowCabinetInterface)
